import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import type { CompanyModel } from 'models/company/entities/CompanyModel';
import authStore from 'stores/auth/AuthStore';
import CompanyCard from 'components/organisms/CompanyCard';
import LoadingComponent from 'components/molecules/LoadingComponent';
import { AppRoutes } from 'routes/AppRoutes';
import useIsStoomHostname from 'hooks/useIsStoomHostname';

const SelectCompanyPage: React.FC = observer(() => {
  const { companyList, loading } = authStore;
  const navigate = useNavigate();

  const { logoToRender } = useIsStoomHostname();

  const handleSelectCompany = (company: CompanyModel) => {
    authStore.setSelectedCompany(company);
    navigate(AppRoutes.DASHBOARD);
  };

  useEffect(() => {
    authStore.getCompanyList();
    authStore.cleanSelectedCompany();
  }, [])

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-background-main">
      <div className="flex flex-col items-center pb-6">
        <img src={logoToRender} alt="Logo" style={{ width: '150px' }} />
      </div>
      <div className="flex flex-col items-center justify-center rounded-xl p-8 bg-white lg:min-w-96 lg:w-min" >
        <div className="flex flex-col items-center justify-center pb-6">
          <p className="font-semibold text-lg">Selecionar empresa</p>
          <p className="text-slate-400 text-sm">Selecione com qual empresa deseja acessar a plataforma</p>
        </div>
        <div className="w-full">
          <div className="flex flex-col justify-start w-full max-h-96 overflow-y-auto">
            {loading
              ? <LoadingComponent isTextHidden />
              : <>
                {companyList.map((item: CompanyModel) =>
                  <CompanyCard
                    key={item.uuid}
                    company={item}
                    onClick={handleSelectCompany}
                  />)}
              </>
            }
          </div>
        </div>
      </div>
    </div>
  );
});

export default SelectCompanyPage;
